import { Box, Card, CardContent, CardMedia, IconButton, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { IPropsGMapImage } from '../Maps/types';
import i18n from '../../i18n';
import { transformGreekToEnglish } from '../../lib/helperFuncs';
  
const ImageCardGMap = (props: IPropsGMapImage) => {
  const {onSubmitFavorite, card } = props;
  const {
    favorite = false,
    img,
    title = '',
    redirect,
    displayFavorite = false,
    enableFavoriteButton = true,
  } = card;

  const [disableLink, setDisableLink] = useState<boolean>(false);
  const [isFavorite, setIsFavorite] = useState<boolean>(favorite);

  useEffect(() => {
    setIsFavorite(favorite);
  
  }, [favorite]);

  return (
    <>
      <Card sx={{ borderRadius: 2, width: 230, height: 250, boxShadow: 0 }}>
        <Box> 
          <Box sx={{ position: 'relative'}}>
            <Link to={!disableLink
              ? `/${redirect}/${card.id}`
              : '#'}>
              <CardMedia
                image={img}
                sx={{ height: '190px', objectFit: 'cover'}}
              />
            </Link>
            {displayFavorite && (
              <Box sx={{ position: 'absolute', top: 0, right: 0 }}>
                <IconButton
                  disabled={!enableFavoriteButton}
                  onMouseOver={() => setDisableLink(true)}
                  onMouseOut={() => setDisableLink(false)}
                  sx={{ color: 'white' }}
                  aria-label={`favorite ${title}`}
                  onClick={() => {
                    setIsFavorite(!isFavorite);
                    onSubmitFavorite(card?.id, !isFavorite);
                  }}>
                  {isFavorite === true
                    ? <FavoriteIcon color='error'
                      sx={{ border: 'solid 2px #fafafa', borderRadius: '50%', padding: 0.5 }} />
                    : <FavoriteBorderIcon
                      sx={{ border: 'solid 2px #fafafa', borderRadius: '50%', padding: 0.5 }} />
                  }
                </IconButton>
              </Box>
            )}
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center'}}>
            <CardContent
              sx={{
                position: 'absolute',
                bottom: -11,
                left: 0,
                right: 0,
                background: 'linear-gradient(to bottom, rgba(0,0,0,0.0) 0%, rgba(0,0,0,0.0) 0%, rgba(0,0,0,0) 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <Box sx={{ textAlign: 'center', m: 1}}>
                <Typography sx={{ fontSize: '1rem', fontFamily: 'unset' }}>{i18n.language === 'en'
                  ? transformGreekToEnglish(`${title}`)
                  : title}</Typography>
              </Box>
            </CardContent>
          </Box>
        </Box>
      </Card>
    </>
  );
};

export default ImageCardGMap;